import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { changePassword } from 'redux/actions/auth';

import UserControlPage from './UserControl.page';

const mapDispatchToProps = { changePassword };

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(UserControlPage));
